import { gql } from '@apollo/client';
import {
  GetCategoriesQuery,
  GetCategoriesQueryVariables,
  GetCategoryQuery,
  GetCategoryQueryVariables,
} from '../../__generated__/queries-web';
import { useFetch } from '../../utils/useFetch';

const GET_CATEGORIES = gql`
  query GetCategories($where: CategoryFilterInput!) {
    categories(first: 1000, where: $where, orderBy: title_ASC) {
      id
      title
      level
      parent {
        id
      }
    }
  }
`;

export const useGetCategories = () =>
  useFetch<GetCategoriesQuery, GetCategoriesQueryVariables>(GET_CATEGORIES);

export const GET_CATEGORY = gql`
  query GetCategory($where: CategoryUniqueFilterInput!) {
    category(where: $where) {
      id
      title
    }
  }
`;

export const useGetCategory = () =>
  useFetch<GetCategoryQuery, GetCategoryQueryVariables>(GET_CATEGORY);
